import * as React from 'react';

import { withRouter } from 'react-router';

import Localization from '../../config/localization';

import PointerLeftSmallSvg from '../Svg/pointerLeftSmall';

import './BackButton.scss';

class BackButton extends React.Component<BackButton.IProps, BackButton.IState> {
  state = {};

  goBack = () => this.props.history.goBack();

  render() {
    return (
      <div onClick={this.goBack} className="text-nowrap back-button-container d-inline-flex eon-red">
        <PointerLeftSmallSvg className="mx-2 my-auto" />
        <h5 className="eon-title h-100 my-auto">{Localization.backButton}</h5>
      </div>
    );
  }
}

export default withRouter(BackButton);
